<template>
  <div class="content">
    <div class="main-content">
      {{ content.content }}
    </div>
    <img-list v-if="content.imgs && content.imgs.length>0" :imgs="content.imgs"/>
  </div>
</template>

<script>
  import ImgList from 'common/comps/img-list/ImgList'

  export default {
    name: 'EssayContent',
    props: {
      content: Object
    },
    components: {
      ImgList
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~stylus/variable"

  .content
    padding-bottom 8px
    .main-content
      line-height: 180%
      padding: 8px
      font-size: $fontsize-large
      color: $color-dark-grey
      white-space: pre-wrap
</style>
